import { render } from "./LoginHeader.vue?vue&type=template&id=40d70cae&ts=true"
import script from "./LoginHeader.vue?vue&type=script&lang=ts"
export * from "./LoginHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__